var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferralCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 38.7V51.3C48 61.8 43.8 66 33.3 66H20.7C10.2 66 6 61.8 6 51.3V38.7C6 28.2 10.2 24 20.7 24H33.3C43.8 24 48 28.2 48 38.7Z",
    fill: "#437ADB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M51.3 6H38.7C28.35 6 24.15 10.11 24.03 20.25H33.3C45.9 20.25 51.75 26.1 51.75 38.7V47.97C61.89 47.85 66 43.65 66 33.3V20.7C66 10.2 61.8 6 51.3 6Z",
    fill: "#C7D7F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralCopy);
export default __webpack_public_path__ + "static/media/referral-copy.85b442c51229c4c9993dbcc44cb484a2.svg";
export { ForwardRef as ReactComponent };